module.exports = __webpack_public_path__ + "img/pellets-loose-yellow.200fd80.svg";